import type { FormFieldOption, HandleInputChange } from "./types";

type SelectInputProps = {
    name: string;
    value?: string | number;
    options: Array<FormFieldOption>;
    disabled?: boolean;
    onChange: HandleInputChange;
};

const normalizeOption = (option: FormFieldOption): FormFieldOption => {
    if (typeof option === "string") {
        return { label: option, value: option, disabled: false };
    }
    return option;
};

const SelectInput = ({ name, value = "", options, disabled, onChange }: SelectInputProps) => {
    const selectedValue = value;

    return (
        <select
            className="form-select"
            name={name}
            value={selectedValue as string | number}
            onChange={(event) => onChange(event, name, event.target.value)}
            disabled={!!disabled}
        >
            {options.map((option) => {
                const opt = normalizeOption(option);
                const optionValue = opt.value;
                return (
                    <option key={String(optionValue)} value={optionValue as string | number | readonly string[] | undefined} disabled={option?.disabled ?? false}>
                        {opt.label}
                    </option>
                );
            })}
        </select>
    );
};

export default SelectInput;
